export const SUPPORT_EMAIL = "support@joinarbor.com";
export const SUPPORT_PHONE = "(833) 204-9563";
export const SUPPORT_ROUTE = "/account/support";

export const DEFAULT_COUNTRY_CODE = "US";
